import { render, staticRenderFns } from "./TranslationSidebar.vue?vue&type=template&id=ede25300&scoped=true&"
import script from "./TranslationSidebar.vue?vue&type=script&lang=ts&"
export * from "./TranslationSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationSidebar.vue?vue&type=style&index=0&id=ede25300&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede25300",
  null
  
)

export default component.exports